import React, { useState } from 'react';
import moment from 'moment';
import swal from 'sweetalert';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { Subtitle, Title } from './AttendeeList';
import { AttendeeIcon, Name, BreakLine } from './Attendee';
import { checkedIn } from '../../../redux/offers';
import { offer } from '../../../services/api';
import { groupByKey, imageFix } from '../../../helpers';
import { Row, Col } from '../../Grid';
import groupLeader from '../../../svg/group-leader.svg';

const Leader = styled.img`
  margin-left: 5px;
  width: 18px;
  margin-top: -2px;
`;

const LeaderText = styled.div`
  font-family: BrandonGrotesque-Regular;
  color: #a6a6a6;
  font-size: 14px;
`;

const CheckInButton = styled.div`
  font-family: BrandonGrotesque-Bold;
  width: 60px;
  height: 30px;
  border-radius: 4px;
  background-color: var(--color-gunmetal);
  font-size: 11px;
  text-align: center;
  color: var(--color-beige);
  line-height: 35px;
  opacity: ${(props) => (props.allowed ? 1 : 0.4)};
  margin: auto;
  cursor: pointer;
`;

const AttendeeC = ({
  attendee,
  group,
  checkedIn,
}: {
  attendee: GroupInvitee;
  group: Group;
  checkedIn: any;
}) => {
  const checkIn = (allowed) => {
    if (!allowed) {
      swal('Click this button to check in a model once your offer begins.');
      return;
    }
    changeCheckin(true);
    offer.checkIn(attendee.claim_id).then((result) => {
      changeCheckin(false);
      checkedIn({
        dealId: attendee.deal_id,
        claimId: attendee.claim_id,
      });
    });
  };

  const [checking, changeCheckin] = useState(false);
  const showButton =
    group.status === 'finalized' &&
    (attendee.status === 'active' || attendee.status === 'accepted');

  const allowed = attendee.claim
    ? moment().isAfter(attendee.claim.starts_at) && moment().isBefore(attendee.claim.ends_at)
    : true;

  return (
    <>
      <Row>
        <Col size="3">
          <AttendeeIcon image={imageFix(attendee.avatar)} />
        </Col>
        <Col size={showButton ? 5 : 8}>
          <Name style={{ marginTop: '17px' }}>
            {attendee.first_name} {attendee.last_name}
            {attendee.owner && <Leader src={groupLeader} alt="" />}
          </Name>
          {attendee.owner && <LeaderText>Group Leader</LeaderText>}
        </Col>
        {showButton ? (
          <Col size={3}>
            <CheckInButton allowed={allowed} onClick={() => checkIn(allowed)}>
              {checking ? 'CHECKING IN' : 'CHECK IN'}
            </CheckInButton>
          </Col>
        ) : null}
      </Row>
      <BreakLine />
    </>
  );
};

const Attendee = connect(null, { checkedIn })(AttendeeC);

const AttendeeTypes = ({
  items,
  title,
  group,
  pluralize = false,
}: {
  items: GroupInvitee[];
  title: string;
  pluralize?: boolean;
  group: Group;
}) => {
  return items && items.length ? (
    <>
      <Subtitle>
        {items.length} {title}
        {pluralize && items && items.length > 1 ? 's' : ''}
      </Subtitle>
      {items.map((item) => (
        <Attendee attendee={item} group={group} key={item.user_id} />
      ))}
    </>
  ) : null;
};

class GroupList extends React.Component<{ group: Group; id: string; offerId: string }, {}> {
  render() {
    const group = this.props.group;
    const owner = { ...group.owner, owner: true };
    const all = [owner, ...group.invitees]
      .filter((a) => a.status !== 'declined')
      .map((a) => ({ ...a, deal_id: this.props.offerId }));
    const data = groupByKey<GroupInvitee>(all, 'status');
    data.secured = [
      ...(data['undefined'] ? data['undefined'] : []),
      ...(data.secured ? data.secured : []),
    ];

    return (
      <div className="modal fade" id={this.props.id}>
        <div className="modal-dialog modal-dialog-attendees" style={{ width: '400px' }}>
          <div className="modal-content modal-body-attendees">
            <div style={{ paddingTop: '10px' }}>
              <button
                className="close float-left"
                style={{ marginLeft: '20px' }}
                data-dismiss="modal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <Title>
                {all.length} {group.status === 'finalized' ? 'Claims' : 'Invitees'}
              </Title>
              <AttendeeTypes group={group} items={data.used} title="Checked in" />
              <AttendeeTypes group={group} items={data.active} title="Waiting to check in" />
              <AttendeeTypes group={group} items={data.secured} title="Accepted" />
              <AttendeeTypes group={group} items={data.uncertain} title="Awaiting response" />
              <AttendeeTypes group={group} items={data.expired} title="Expired" />
              <AttendeeTypes group={group} items={data.canceled} title="Cancelled" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GroupList;
